var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddIconWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add-icon",
    transform: "translate(-28 -14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1157",
    "data-name": "Rectangle 1157",
    width: 16,
    height: 16,
    transform: "translate(28 14)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4927",
    "data-name": "Path 4927",
    d: "M11,11V5h2v6h6v2H13v6H11V13H5V11Z",
    transform: "translate(24 10)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIconWhite);
export default __webpack_public_path__ + "static/media/add-icon-white.19dd45304ef641b380a4c80f1fef08f5.svg";
export { ForwardRef as ReactComponent };